const en = {
  header: {
    home: 'Home Page',
    media: 'Medium',
    solution: 'Solution',
    travel: 'Continents Collections',
    recruit: 'Partner Recruitment',
    overview: 'Overview',
    overview_: 'Get vour brands or products displaved among selected consumers via Trave -X exclusive data applications on toppublishers in China, or Travel-X e-commerce network partners.',
    portus: 'Bring airlines steady ROAS with performance marketing, while deliver sophisticated-designed marketing activities totarget customers.',
    portusPlus: 'Reach the confirmed travelers (pre-trip and during-trip), post-trip travelers or frequent flyers by leveraging Trave-X flights itinerary database, while get displayed on selected publishers in China.',
    portusAir: 'Provide airlines "end-to-end" with options on offer creation and promotion, to generate best revenue stream andseamless user experience.',
    portusFin: 'A full solution for mobile banking on travel & mobility scenario, to improve interface for bank customers whiletravelling.',
    travel_: '“A pocket guide for global traveling and shopping”',
    airport: 'Airports',
    airport_: 'Travel-X connects millions of travelers via partners andpromote merchants of airports under a CPS (cost per sale)model',
    free: 'Duty-Frees',
    free_: 'Travel-X increases both arrival customers and online salesfor duty-frees.',
    brand: 'Travel Retail Brands',
    brand_: 'Travel-X builds brand-awareness for travel retail brandsamong Chinese customers and leads to transparentconversion path.',
    place: 'In-dest Merchants',
    place_: 'Travel-X promotes in-dest merchants globally, by leveragingcommercialpartners.'
  },
  home: {
    travelx_one: 'With data and tech capability, Travel-X is building a GATEWAY in travel industry by connecting service suppliers and customers efficiently. Travel-X offers solutions for airlines, travel retail brands or retailers, and commercial banks. Meanwhile, Travel-X owns a brand “Continents Collections” that offers travel service for customers.',
    travelx_two: 'Founded in 2016,  Travel-X has 4 rounds of VC financing and runs a joint venture with Travelsky, the only GDS in China.',
    col1: 'Flights booking data accumulated',
    col2: 'Access to itinerary data in China',
    col3: 'Registered user of Continents Collections',
    col4: 'Frequent flyers data covered',
    solution: 'Solutions',
    s1: 'Travel-X advanced capability in the data, tech and business operation, ',
    s2: 'promises the efficiency of user acquisition and conversion, ',
    s3: 'meanwhile ',
    s4: 'improving the customer service and monetization of partners.',
    solu1: 'The solutions are for ',
    solu2: 'airlines, travel retail brands (destination marketing), and finance institute (commercial banks)',
    solution1: 'Airlines Marketing Cloud',
    solution2: 'Airlines Offer Creation and Recommendation Engine',
    solution3: 'Data-Driven Digital Marketing Solution',
    solution4: 'Fin-Tech to Build Online Travel Service Module',
    more: 'More',
    travel: 'Continents Collections',
    travel1: 'A brand of Travel-X, is',
    travel2: '“a pocket guide for global traveling and shopping”',
    travel3: '. that covers most travel scenarios from pre-trip, during trip to post-trip, from travel service booking, in-dest payment, and e-shopping. Continents Collections serves customers via APP of commercial banks and ERP system of large companies in China,',
    travel4: 'dedicated to high-quality, less-bothering travel experience.',
    customer_case: 'Customer Success',
    swiper1: 'PortusFin is serving CGB, the largest commercial bank in China, by offering full travel service to customers on CGB APP. The solution provides 50K incremental DAU and support  its hierarchy membership scheme.',
    swiper2: 'PortusPlus started to serve EL Travel Retail since 2019. By precisely targeting pre-trip, during-trip and post-trip confirmed travelers, and leveraging leading travel retailers, Travel-X offers efficient and transparent digital marketing for ELC.',
    swiper3: 'Travel-X offers full solutions for CZ, covering membership growth, offer creation, and overseas digital marketing. Portus is deployed to realize high-ROI and data-driven marketing, while PortusAir is applied to manage, generate and distribute products and packages.',
    swiper4: 'Portus serves Xiamen Airlines on both domestic and overseas digital marketing, making MF the first airlines to apply Facebook dynamic travel ads in Asia. Meanwhile MF joins PortusFin and Continents Collections to improve revenue on ancillary service.',
    swiper5: 'Jaeger-Lecoultre deployed PortusPlus on travel retail digital marketing, where both the confirmed travelers data and the user profile system were applied (i.e. consumption data, shopping behaviors, etc.)'
  },
  footer: {
    portus: 'Portus (Beijing) Technology Co.',
    address: 'No. 71 Lumicang Hutong, Dongcheng Dist. Beijing, China',
    phone: 'Phone: ',
    mail: 'Mail: ',
    follow: 'Follow us',
    scan: 'http://travelmall.portus.cn/2023/04/49f4ddccbda94f458f3b332ea53dccb3.png',
    shanghai: 'Shanghai Dongmei Online Travel Agency Co. , Ltd.'
  },
  media: {
    media: 'Travel-X Media',
    self: 'Campaigns on Continents Collections',
    self_content: 'Continents Collections is a travel service brand of Travel-X, offering travel service booking, e-shopping and payment (credit payment, mileage redemption, etc.) for customers via APP of commercial banks and ERP system of large companies in China. Campaigns can be launched on banner and pop-up button, to reach quality customers.',
    more: 'See More',
    dataMedia: 'Campaigns driven by Data, on Landmark Media',
    dataMediaContent: 'Travel-X is the leading travelers data consolidator in China, by collecting itinerary data from GDS and airlines data partner and building user profile system with data from media and financial institutes. Travel-X applies the data on leading Chinese media and delivers digital marketing campaigns for objectives including brand awareness, engagement, or conversion.',
    dataSource: 'About DATA',
    overview: 'Overview',
    overview1: 'Travel-X enjoys the best coverage on travel data, including flight routes, fare and inventory, flight status, itinerary and travelers user profile.',
    overview2: 'Travel-X user profile system leverages various data sources to portray the travel and shopping preference, and demographic info of customers.',
    value: 'How Is It Used',
    realize: '',
    target: 'Targeting',
    target_: 'Reaching out to the custom audience',
    evaluation: 'Evaluation',
    evaluation_: 'Evaluating the conversion performance',
    insight: 'Insight',
    insight_: 'Observing the customers behavior',
    lack: 'The Data Is',
    realize_: '',
    unique: 'Unique',
    unique_: 'The only player to consolidateand apply itinerary data',
    dynamic: 'Dynamic',
    dynamic_: 'Retrieve itinerary data in real-time per booking made',
    comprehensive: 'Comprehensive',
    comprehensive_: 'Cover more than 90% flight booking in China',
    DMP: 'DMP + MEDIA',
    DMP_content: 'The DMP system of Travel-X is used to generate “custom audience”, which will be used on leading social and online media in China. All kinds of ads format and leading Chinese media can all be used, including native ads, social ads, and news feed, etc.',
    selfSource: 'Media Resources Owned by Travel-X',
    selfSourceContent: 'Continents Collections owns millions of registered users and a million monthly active users.',
    position: 'ADS WILL ON',
    APP: 'APP of commercial banks, airlines, hotel chains, WeChat, etc.',
    customers: 'CUSTOMERS',
    selfCustomers: 'Customers',
    selfCustomer_: 'Customers of “Continents Collections”',
    selfCustomerContent: 'Customers of “Continents Collections”',
    partner: 'Customers from partners',
    partner_: 'Credit cards partners, APPs of commercial banks, employees of large companies, etc.',
    userData: 'User Data',
    userData_: 'Over 20 million independent users, with required authorization.',
    userProfile: 'User Profile',
    userProfile_: 'Independently developed data analysis platform, integrating over 90% of travelers itinerary data and flight booking records.',
    return: 'Return for Clients',
    filter: 'Customer Group Screening ',
    filter_1: 'Through an independently developed user data platform, Travel-X integrates and collects data to export a collection of user-specific behavior data, which can be applied to a variety of marketing scenarios, providing users with personalized push services that meet marketing needs.',
    filter_2: 'By integrating the air travel crowd, Travel-X can dynamically identify the crowd that has already booked and ready to set off, and conduct precision marketing activities based on flight data.',
    cover: 'Full Media Coverage on Target Customer Group',
    cover_1: 'Travel-X can independently access partner application apps through H5 integration.',
    cover_2: 'Travel-X can apply relevant data to third- party platforms for advertising placement.',
    conversion: 'Opportunity to Conversion',
    conversion_1: 'Travel-X builds a close loop for marketing activities by connecting to the purchase behavior.',
    conversion_2: ''
  },
  solution: {
    portus: 'Portus: Airlines Marketing Cloud',
    marketing: 'Mar-Tech',
    marketing_: 'Travel-X provides a cloud computing system for Chinese and international carriers on digital marketing and membeship marketing. This system supports airlines in delivering advanced dynamic ads that displays real-time airfare prices, origin and destination information based on user profiles, thereby increasing the relevance and effectiveness, and bringing an ROAS (or ROI) to 10+.',
    experience: 'Are you experiencing these challenges with your partners?',
    integrated: 'Integrated Marketing Service',
    integrated_: 'Travel-X offers a range of marketing services to airlines, leveraging our expertise and resources to provide comprehensive solutions that address various aspects of marketing, including membership, data analysis, planning, creatives, IT development, and content management, etc.',
    portusAir: 'PortusAir: Airlines Content Management and Offer Creation',
    suffer: 'Does your product design suffer from the following?',
    suffer1: 'Insufficient ancillary ',
    suffer1_: 'service for bundling',
    suffer2: 'Only standard product and ',
    suffer2_: 'packaging, with bare personalization',
    suffer3: 'Limited distribution channels ',
    suffer3_: 'and sale methods',
    realize: 'PortusAir offers a content management solution to help airlines transform their businesses to be more retail-oriented:',
    realize1: 'Automated and standardized on ancillary service management',
    realize2: 'Unified clearing and settlement system',
    realize3: 'A product profile system based on channels and user data provided by GDS',
    realize4: 'Ability to create personalized offer',
    portusFin: 'PortusFin ',
    portusFin_: 'PortusFin aims to provide a comprehensive and personalized travel experience that meets the needs and preferences of bank customers.',
    service: 'Service',
    service_: 'PortusFin brings together a range of travel-related services, including flights, accommodations, destination shopping, tourist attractions, etc. The solution uses user profiling and travel scenarios to engage existing users and boost activity and transaction conversion on bank apps.',
    way: 'Integration',
    way_: 'Travel-X independently builds H5 pages/mini-program that runs on bank apps, where users can log in to the platform directly through the bank app and access the services provided by Travel-X. This approach allows Travel-X to reach a wider audience and provide a seamless user experience that is integrated with existing banking services.',
    uniqueness: 'Uniqueness',
    uniqueness_: "PortusFin is one of the few platforms in China that has access to flight passenger itinerary data, which, under user authorization, provides customized trip information and recommended service reservations based on the user's travel scenario and profiling.",
    coop: 'Partnership',
    coop1: 'H5 or Mini-Program page access to mobile banking/credit card/bank apps',
    coop2: 'API integration to the online cashier of mobile banking, and building a close-loop;',
    coop3: 'Building access to standardized service, such as flights, hotels, tourist attractions, and packages;',
    coop4: 'Travel retail brands building stores brand hall online and offering discounts and coupons;',
    coop5: 'Identifying confirmed travelers and conduct destination marketing based on travel scenario, profiling system and the very content/benefits;',
    recruit: 'Partner Recruitment',
    solution_img_width: '67.6vw',
    solution_img_height: '23.4vw',
  },
  travel: {
    platform: 'Travel Service Meta',
    APP: 'Travel Management APP',
    APP_: 'Travel-X’s Corporate Travel Tool for B2B Clients',
    engine: 'Recommendation Engine',
    joint: 'Joint-Marketing',
    joint_: 'Continents Collections can leverage its own service capabilities and platform resources to support various joint marketing modes:Employee Pop-up Store, or any forms of Pop-up Store',
    recruit: 'Partners',
    channelCase: 'Distribution Partners',
    offline: 'Member Experience Center',
    engine_width: '68.5vw',
    engine_height: '40vw'
  },
  recruit: {
    closeLoop: 'A Close-Loop for Clients',
    adver: 'Digital Marketing',
    adver1: 'Digital Advertising: Travel-X is a leading, tech-drivemn digital marketing service provider in China that specializes in the travel and tourism retail industry, offering a full range of digital advertising services to advertisers, leveraging its unique capabilities in data integration and media coverage.',
    adver2: 'Dynamic Ads: Travel-X is the first technology service provider in China to apply dynamic ads in the travel industry. By integrating real-time data on service and product prices and inventory status, Travel-X offers personalized and highly relevant ad content to users.',
    channel: 'Channel ',
    channel_: 'Integrated into bank apps and enterprise platforms, the Continents Collections of Travel-X leverages the traffic resources of platforms above to help partners acquire customers, including airlines, travel retail brands, travel retailers, and destinations. The platform provides various user acquisition opportunities from exposure to engagement.',
    platform: 'Platform – Membership',
    platform_: 'Covering millions of users and consumers through various touchpoints such as bank APPs and enterprise platforms,  “Continents Collections” can provide efficient transaction conversion for airlines, hotel chains, destinations, travel retail brands, and duty-free shops.',
    vip: 'Platform – Retention',
    vip_: 'The membership system of “Continents Collections” allows customers to earn airlines mileage or points of partners, or pay by mileage or points as well. Meanwhile, by using real-time dynamic flight data, Travel-X can activate existing users in travel scenarios and improve engagement.',
    beijing: 'Bank of Beijing app',
    guangfa: 'Guangfa Bank app',
    ICBC: 'ICBC APP',
    union: 'China UnionPay app',
    CCB: 'CCB APP',
    jinzhou: 'Jinzhou Bank appAPP'
  },
  portus: {
    dynamic: 'Mar-Tech: Dynamic Ads',
    dynamic_: 'Travel-X is the only company in China who applies airfare system to mar-tech',
    dashboard: 'Mar-Tech: Dashboard',
    offer: 'Travel Offers',
    marketing1: 'Planning and Execution of Online',
    marketing2: '& Offline Marketing Acitivites',
    content1: 'Text Draft, Writing',
    content2: 'and Editing',
    live1: 'Live',
    live2: 'Streaming',
    data1: 'Data',
    data2: 'Analysis',
    joint1: 'Partnership and',
    joint2: 'Co-Marketing',
    operate: 'Live Streaming',
    popUp: 'Pop-Up',
    online: 'Online',
    output: 'Video Content Production'
  },
  portusAir: {
    history: 'The History of Airline Retailing',
    history1: 'Weak infrastructure with many unresolved problems',
    history2: 'Lack of quality ancillary service',
    history3: 'Low frequency and few active users',
    history4: 'Much better customer relationship of distribution channel',
    content1: 'Distribution channels complete everything',
    content2: 'Airlines building e-commerce platform to sell',
    content3: 'NDC provides an infrastru-cture for airlines to offer more tailor-made products and services',
    content4: 'Abandoning concepts of PNR and EMD and selling personalized products through airline.com and distribution channels',
    line1: 'GDS Era',
    line2: 'Airline.com Era',
    line3: 'Offer/Order Era',
    line4: 'Modern Airline Retailing',
    consult: 'Travel-X Airlines Team:',
    consultContent: "For most Chinese airlines, trying to acquire customers online is no longer meaningful. Airlines should focus on leveraging their own strengths and values to transform their retailing strategies and create value for partners within the partner's ecosystem in order to enhance revenue generation capabilities.",
    system: 'Airlines Benefit From Eco-System',
    service: 'Service Standards: Admission management and delivery standards for products and services.',
    technology: 'echnical Standards: Standardized access methods similar to platforms like Taobao/Meituan',
    pay: 'Payment and Settlement Standards: Acceptable payment methods, settlement rules, etc'
  },
  offline: {
    offline: 'Member Experience Center',
    offline_: 'Continents Collections, partnering with banks, runs store in densely populated areas such as commercial districts and tourist attractions, where customers can pick-up or purchase goods, or rest and take financial service.',
    offline1: 'The Zhongguancun Branch of Bank of Beijing, sponsored the store at “the Great Wall” of Continents Collections. Customers who are issued credit cards on-site will get coupons and discounts when shopping. Commercial banks benefit from the gathering of customers and the seamless experience.',
    offline2: 'At present, four experience stores have been opened in Beijing, and two more in Shanghai and Chengdu, spme of which are pop-up stores.',
    left: 'Design Sketch',
    right: 'Store At the Great Wall'
  },
  group: {
    coopGroup: 'Corporate Pop-up Store',
    coopGroup_: 'Continents Collections, partnering with banks to launch corporate pop-up store in large companies, mainly in Beijing. Selected products are directly introduced into the enterprise to provide on-site purchasing services for employees, meanwhile commercial banks and partners will promote their own service or products to the coming customers.',
    content1: 'Customers who are issued credit cards on-site will get coupons and discounts when shopping. Customers who make the payment using the very credit card will have further discount. Commercial banks join the scheme to promote their credit cards business.',
    content2: '',
    live: 'On-Site'
  },
  channel: {
    channel_: 'Continents Collections mainly partner swith commercial banks,airlines,hotelchains,and corporate welf are platforms.',
    bank: 'Commercial Banks',
    bank_: 'H5/Mini-Program integrated in bank APPs, including ICBC, CCB, etc.',
    travel: 'Travel Loyalty Program',
    travel_: 'Partnering with loyalty programs of airlines and hotels where customers pay by mileage or points;',
    partner: 'Corporate ',
    partner_: 'H5 integrated in leading corporate welfare platform, including China Mobile, Sinopec, FESCO, etc.',
    popUp: 'Corporate Pop-Up Store',
    popUp_: '“Continents Collections” sets up Pop-up Store in enterprises.',
    group: 'Other Partners',
    group_: 'Continents Collections serves the users and members of retail chain and real-estate  brands.'
  },
  picture: {
    dataMedia: 'http://travelmall.portus.cn/2023/05/4115dc864d774fbbad3c5f9a908fc403.png',
    travelBanner: 'http://travelmall.portus.cn/2023/04/90675574445e4f3eb8f32c65bba2d98f.png',
    partner: 'http://travelmall.portus.cn/2023/04/c9efeeec3ad94aebb84873618d32ef71.png',
    recruit: 'http://travelmall.portus.cn/2023/05/788fd276e37f4dad8977b6b86d5651df.png',
    dynamic: 'http://travelmall.portus.cn/2023/04/1fbe98445de54dc9a17e7eb1920a1ee0.png',
    system: 'http://travelmall.portus.cn/2023/04/ee65afe061c3494dadd89342c6654e8a.png',
    disadvantage: 'http://travelmall.portus.cn/2023/04/4e2d37e7b94e4c808a2f56ec2f60665d.png',
    advantage: 'http://travelmall.portus.cn/2023/04/2e658a13716a4fcea21814de0c822486.png',
    travel: 'http://travelmall.portus.cn/2023/04/d88433c8eb2547818bed234526b19b0a.png',
    swiper1: 'http://travelmall.portus.cn/2023/04/a5fe2ad3c7594883b33575f9d27c087a.png',
    swiper2: 'http://travelmall.portus.cn/2023/04/ea4ed55daa804b1ebf7387a6231c6204.png',
    swiper3: 'http://travelmall.portus.cn/2023/04/b2e33d655d7048ef9897d3ce989fda00.png',
    swiper4: 'http://travelmall.portus.cn/2023/04/e74fe222d390419bbeb970557ad5d0a1.png',
    swiper5: 'http://travelmall.portus.cn/2023/04/b1aabd378de64c30b9e867c104b12fe3.png',
    media: 'http://travelmall.portus.cn/2023/04/6e4dffa9b8ef46b193d8c656083247a9.png',
    mediaValue: 'http://travelmall.portus.cn/2023/05/fae2cf3dd12f4b0299d9116a504fad10.png',
    mediaLack: 'http://travelmall.portus.cn/2023/05/d77c0a8dd85a448298859d11f78982e3.png',
    return1: 'http://travelmall.portus.cn/2023/05/1a623f88b00047288ed5f8b23a0e269b.png',
    return2: 'http://travelmall.portus.cn/2023/05/786feec581724fa0a90356751768352f.png',
    return3: 'http://travelmall.portus.cn/2023/05/68e73544c15d470ab27f0b0fb9545d65.png',
    historyImg1: 'http://travelmall.portus.cn/2023/05/a5fdce2f893d4f09aa9ed096ed4dd932.png',
    historyImg2: 'http://travelmall.portus.cn/2023/05/df357ae18c5e443eb050014a668aa1d3.png',
    historyImg3: 'http://travelmall.portus.cn/2023/05/cbe209f286c44d6c958d9b43e7b12fd0.png',
    historyImg4: 'http://travelmall.portus.cn/2023/05/2af6ccc7bb5c44e5b9d05a382f46184b.png'
  },
  style: {
    width: '44vw'
  }
}

export default en